<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-dialog v-model="dialogFechamentoDia" width="80%"> 
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeDialogFechamentoDia">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('fechamentoDia.title') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-form ref="formFechamentoDia" v-model="formValidadoFechamentoDia">
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editedFechamento.observacoes" :label="$tc('system.labels.observation', 2)" />
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="closeDialogFechamentoDia">{{ $t('button.cancel') }}</v-btn>
                    <v-btn color="primary" @click="insertFechamentoDia">{{ $t('button.closeDay') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Fechamento financeiro do dia: o mesmo do mês (RELSubsidioMensal), para um único dia -->
        <v-dialog v-model="dialogFecharDiaFinanceiro" max-width="560" persistent>
            <v-card>
                <v-card-title class="headline">{{ $t('closingDay.closeTitle') }}</v-card-title>
                <v-card-text>
                    <p>{{ $t('closingDay.closeConfirm', { dia: dtReferenciaFormatada }) }}</p>
                    <p class="text-caption grey--text text--darken-1">{{ $t('closingDay.closeHint') }}</p>
                    <v-textarea v-model="observacoesFechamentoDiaFinanceiro" :label="$t('closingMonth.notes')" rows="3"
                        counter="1000" maxlength="1000" outlined dense></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text :disabled="salvandoFechamentoDiaFinanceiro" @click="dialogFecharDiaFinanceiro = false">{{ $t('button.cancel') }}</v-btn>
                    <v-btn color="success" class="white--text" :loading="salvandoFechamentoDiaFinanceiro" @click="confirmarFecharDiaFinanceiro">
                        {{ $t('closingDay.closeButton') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogReabrirDiaFinanceiro" max-width="560" persistent>
            <v-card>
                <v-card-title class="headline">{{ $t('closingDay.reopenTitle') }}</v-card-title>
                <v-card-text>
                    <p>{{ $t('closingDay.reopenConfirm') }}</p>
                    <v-textarea v-model="motivoReaberturaDiaFinanceiro" :label="$t('closingMonth.reason')" rows="3"
                        counter="1000" maxlength="1000" outlined dense
                        :rules="[(v) => !!(v && v.trim()) || $t('closingMonth.reasonRequired')]"></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text :disabled="salvandoFechamentoDiaFinanceiro" @click="dialogReabrirDiaFinanceiro = false">{{ $t('button.cancel') }}</v-btn>
                    <v-btn color="warning" class="white--text" :loading="salvandoFechamentoDiaFinanceiro"
                        :disabled="!motivoReaberturaDiaFinanceiro || !motivoReaberturaDiaFinanceiro.trim()" @click="confirmarReabrirDiaFinanceiro">
                        {{ $t('closingDay.reopenButton') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <UpdateViagemDialog
            ref="updateViagemDialog"
            :dialog="dialogUpdateViagem"
            :viagem="editedViagem"
            :dt-referencia="dtreferencia"
            :bloqueado-mes-fechado="diaEmMesFechado"
            :aviso-mes-fechado="avisoMesFechadoDia"
            :map-key="key"
            :motivos="motivos"
            :observacoesAbertura="observacoesAbertura"
            :observacoesFechamento="observacoesFechamento"
            :observacoesConciliacaoManual="observacoesConciliacaoManual"
            :motivoConciliacaoManual="motivoConciliacaoManual"
            @updated="onViagemUpdated"
            @revalidated="onViagemRevalidated"
            @close="closeDialogEditarViagem"
        />

        <v-dialog v-model="dialogAssociarEmbarques" max-width="720px" persistent>
            <v-card>
                <v-toolbar dark color="primary" dense flat>
                    <v-toolbar-title>{{ $t('fechamentoDia.embarques.associateTitle') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeDialogAssociarEmbarques">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pt-4">
                    <p class="mb-4">
                        {{ $t('fechamentoDia.embarques.selectedCount', { count: embarquesSelected.length }) }}
                    </p>
                    <v-autocomplete
                        v-model="idViagemAssociacaoSelected"
                        :items="viagensParaAssociacao"
                        item-text="label_busca"
                        item-value="id_viagem_grid"
                        :label="$t('fechamentoDia.embarques.selectTrip')"
                        :no-data-text="$t('fechamentoDia.embarques.noTripsAvailable')"
                        clearable
                    >
                        <template v-slot:item="{ item }">
                            <v-list-item-content class="py-2">
                                <v-list-item-title class="font-weight-medium">
                                    <v-chip x-small label color="primary" class="mr-2">{{ item.cod_linha }}</v-chip>
                                    <span>{{ item.numero_ordem_veiculo_realizado || '—' }}</span>
                                    <span class="grey--text text--darken-1 ml-2">{{ item.descricao_sentido }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle class="mt-1 d-flex align-center flex-wrap">
                                    <span>{{ $t('fechamentoDia.embarques.tripOption.departure') }}: {{ item.horario_saida_realizada_extenso }}</span>
                                    <v-icon small class="mx-1">mdi-arrow-right</v-icon>
                                    <span>{{ $t('fechamentoDia.embarques.tripOption.arrival') }}: {{ item.horario_chegada_realizada_extenso }}</span>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-if="item.motorista_realizado" class="caption mt-1">
                                    {{ $t('fechamentoDia.headers.driver') }}: {{ item.motorista_realizado }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                        <template v-slot:selection="{ item }">
                            <span class="d-flex align-center flex-wrap">
                                <strong class="mr-2">{{ item.cod_linha }}</strong>
                                <span class="grey--text text--darken-1">
                                    {{ item.horario_saida_realizada_extenso }}
                                    <v-icon x-small class="mx-1">mdi-arrow-right</v-icon>
                                    {{ item.horario_chegada_realizada_extenso }}
                                </span>
                                <span v-if="item.numero_ordem_veiculo_realizado" class="ml-2 caption">
                                    · {{ item.numero_ordem_veiculo_realizado }}
                                </span>
                            </span>
                        </template>
                    </v-autocomplete>
                    <v-alert
                        v-if="viagensParaAssociacao.length === 0"
                        type="info"
                        dense
                        text
                        class="mt-2 mb-0"
                    >
                        {{ $t('fechamentoDia.embarques.noTripsAvailable') }}
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeDialogAssociarEmbarques">{{ $t('button.cancel') }}</v-btn>
                    <v-btn
                        color="primary"
                        :disabled="!idViagemAssociacaoSelected || embarquesSelected.length === 0"
                        @click="confirmAssociarEmbarques"
                    >
                        {{ $t('fechamentoDia.embarques.associate') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <v-toolbar-title>{{ $t('fechamentoDia.title') }}</v-toolbar-title>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :value="dtReferenciaFormatada"
                                    :label="$t('datetime.referenceDate')"
                                    clearable
                                    v-bind="attrs"
                                    v-on="on"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dtreferencia"
                                :label="$t('datetime.referenceDate')"
                                clearable
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <LazySelect
                            ref="empresaSelect"
                            get-url="getEmpresaslazy"
                            text="razao_social"
                            value="id_empresa"
                            :label="$tc('company.self', 1)"
                            @input="idEmpresaSelected = $event"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <LazySelect
                            ref="unidadeSelect"
                            get-url="getUnidadeslazy"
                            text="cod_unidade"
                            value="id_unidade"
                            :label="$t('qrcodeAccessReport.headers.unit')"
                            @input="idUnidadeSelected = $event"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" class="d-flex align-center" style="gap: 10px;">
                        <v-btn color="primary" @click="buscaFechamentoDia" small fab>
                            <v-icon class="white--text">mdi-magnify</v-icon>
                        </v-btn>

                        <!-- Fechamento financeiro do dia: congela viagens e valores do subsídio do dia -->
                        <v-tooltip v-if="podeFecharDiaFinanceiro && !fechamentoDiaFinanceiro && !fechamentoMesDoDia" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="success" class="white--text" v-bind="attrs" v-on="on"
                                    :disabled="!statusDiaFinanceiroCarregado || !diaEncerrado"
                                    @click="abrirDialogFecharDiaFinanceiro">
                                    <v-icon>mdi-lock-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('closingDay.closeButton') }}</span>
                        </v-tooltip>

                        <v-tooltip v-if="podeReabrirDiaFinanceiro && fechamentoDiaFinanceiro && !fechamentoMesDoDia" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="warning" class="white--text" v-bind="attrs" v-on="on"
                                    @click="abrirDialogReabrirDiaFinanceiro">
                                    <v-icon>mdi-lock-open-variant-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('closingDay.reopenButton') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <!-- Mês fechado: o dia está congelado e a API recusa qualquer alteração nas viagens. -->
        <v-alert v-if="diaEmMesFechado || fechamentoDiaFinanceiro" type="info" dense text icon="mdi-lock-outline"
            style="margin: 0 12px 10px; border-radius: 10px">
            <template v-if="fechamentoDiaFinanceiro">
                <div style="font-weight: 600;">{{ $t('closingDay.closedTitle') }}</div>
                <div>{{ resumoFechamentoDiaFinanceiro }}</div>
                <div v-if="fechamentoDiaFinanceiro.observacoes">{{ fechamentoDiaFinanceiro.observacoes }}</div>
                <div v-if="fechamentoMesDoDia" style="margin-top: 4px;">{{ $t('closingDay.monthClosedHint') }}</div>
            </template>
            <template v-else>{{ avisoMesFechadoDia }}</template>
        </v-alert>

        <MerusDataTable 
            :headers="headersLinhas" 
            :items="linhas"
            :loading="loadingLinhas"
            :default-multi-sort="defaultMultiSortLinhas"
            @update:displayedItems="displayedLinhasItemsForExport = $event"
        >
        <template v-slot:toolbar>
            <CadastroToolbar
                title="Linhas"
                :token="token"
                :items="displayedLinhasItemsForExport !== null ? displayedLinhasItemsForExport : linhas"
                csv-title="linhasfechamentodia"
                :csv-headers="headersLinhas"
                pdf-title="Linhas Fechamento do Dia"
                :pdf-headers="headersLinhas"
                pdf-filename="linhasfechamentodia"
                hide-search
            />
        </template>
        <template v-slot:item.status_linha="{ item }">
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-icon v-if="item.status_linha == 1" color="green" v-on="on">mdi-check</v-icon>
                    <v-icon v-else-if="item.status_linha == 2" color="green" v-on="on">mdi-lock-outline</v-icon>
                    <v-icon v-else color="red" v-on="on">mdi-alert-box-outline</v-icon>
                </template>
                <span>{{ item.descricao_status_linha }}</span>
            </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" :color="idLinhaFiltered === item.id_linha ? 'red' : 'blue'" @click="filterLinha(item)">mdi-magnify</v-icon>
            <v-icon small class="mr-2" color="green" @click="fecharDia(item)" :disabled="item.status_linha == 2 || diaEmMesFechado">mdi-calendar-check</v-icon>
        </template>
        </MerusDataTable>

        <MerusDataTable 
            :headers="headers" 
            :items="viagensFiltered"
            :loading="loading"
            :default-multi-sort="defaultMultiSort"
            :item-class="getViagemRowClass"
            @update:displayedItems="displayedViagensItemsForExport = $event"
        >
        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$tc('trip.self', 2)"
                :token="token"
                :items="displayedViagensItemsForExport !== null ? displayedViagensItemsForExport : viagensFiltered"
                csv-title="viagensfechamentodia"
                :csv-headers="headers"
                pdf-title="Viagens Fechamento do Dia"
                :pdf-headers="headers"
                pdf-filename="viagensfechamentodia"
                hide-search
            >
                <template v-slot:add v-if="linhas.length > 0">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark small class="mb-2" v-on="on" fab @click="openDialogEditarViagem(null)">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('tripOperation.addTrip') }}</span>
                    </v-tooltip>
                </template>
            </CadastroToolbar>
        </template>
        <template v-slot:item.flag_viagem_a_conferir="{ item }">
            <div class="d-flex align-center">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-if="isViagemInvalida(item)" color="deep-orange darken-2" v-on="on">mdi-close-circle-outline</v-icon>
                        <v-icon v-else-if="item.id_fechamento_dia != null" color="green" v-on="on">mdi-lock-outline</v-icon>
                        <v-icon v-else-if="item.flag_viagem_a_conferir == 0" color="green" v-on="on">mdi-check</v-icon>
                        <v-icon v-else color="red" v-on="on">mdi-alert-box-outline</v-icon>
                    </template>
                    <span>{{ item.descricao_status }}</span>
                </v-tooltip>
                <v-chip
                    v-if="isViagemInvalida(item)"
                    x-small
                    color="deep-orange"
                    dark
                    class="ml-2"
                >
                    {{ $t('fechamentoDia.invalidTrip.badge') }}
                </v-chip>
            </div>
        </template>

        <template v-slot:item.actions="{ item }">   
            <v-icon small class="mr-2" color="green" @click="openDialogEditarViagem(item)" :disabled="item.id_fechamento_dia != null">mdi-pencil</v-icon>
        </template>
        </MerusDataTable>

        <MerusDataTable
            :headers="headersEmbarques"
            :items="embarquesFiltered"
            :loading="loadingEmbarques"
            :show-select="true"
            item-key="id_embarque"
            v-model="embarquesSelected"
            :default-multi-sort="defaultMultiSortEmbarques"
            @update:displayedItems="displayedEmbarquesItemsForExport = $event"
        >
        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('fechamentoDia.embarques.title')"
                :token="token"
                :items="displayedEmbarquesItemsForExport !== null ? displayedEmbarquesItemsForExport : embarquesFiltered"
                csv-title="embarquesfechamentodia"
                :csv-headers="headersEmbarques"
                pdf-title="Embarques Fechamento do Dia"
                :pdf-headers="headersEmbarques"
                pdf-filename="embarquesfechamentodia"
                hide-search
            >
                <template v-slot:add>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="primary"
                                dark
                                small
                                class="mb-2"
                                v-on="on"
                                fab
                                :disabled="embarquesSelected.length === 0"
                                @click="openDialogAssociarEmbarques"
                            >
                                <v-icon>mdi-link-variant</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('fechamentoDia.embarques.associateSelected') }}</span>
                    </v-tooltip>
                </template>
            </CadastroToolbar>
        </template>
        <template v-slot:item.autorizado_extenso="{ item }">
            <v-chip
                x-small
                :color="item.autorizado == 1 ? 'green' : item.autorizado == 0 ? 'red' : 'orange'"
                dark
            >
                {{ item.autorizado_extenso }}
            </v-chip>
        </template>
        </MerusDataTable>
    </v-container>
</template>
<script>
import apiController from '@/utils/apiController';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import L from 'leaflet';
import DateUtils from '../utils/dateutils';
import UpdateViagemDialog from './Dialogs/UpdateViagemDialog.vue';
import LazySelect from './Selects/LazySelect.vue';
import fechamentoMesMixin from '@/mixins/fechamentoMesMixin';
import EventBus from '@/utils/eventBus';


export default {
    mixins: [fechamentoMesMixin],
    components: {
        MerusDataTable,
        CadastroToolbar,
        UpdateViagemDialog,
        LazySelect,
    },
    data: () => ({
        loading: false,
        formValidado: false,
        idEmpresaSelected: null,
        idLinhaSelected: null,
        idUnidadeSelected: null,
        dtreferencia: null,
        displayedLinhasItemsForExport: null,
        displayedViagensItemsForExport: null,
        displayedEmbarquesItemsForExport: null,
        embarques: [],
        embarquesSelected: [],
        loadingEmbarques: false,
        dialogAssociarEmbarques: false,
        idViagemAssociacaoSelected: null,
        viagens: [],
        linhas: [],
        veiculos: [],
        sentidos: [],
        cercas: [],
        classificacoes: [],
        loadingLinhas: false,
        config: null,
        timeProps: {
          useSeconds: true,
        },
        dti: null,
        dtf: null,
        dialogUpdateViagem: false,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        center: [-22.88746, -43.29185],
        currentCenter: [-22.88746, -43.29185],
        mapOptions: {
            zoomSnap: 0.5,
        },
        zoom: 12,
        map: null,
        editedViagem: {
            id_viagem_grid: null,
            id_viagem_prevista: null,
            horario_saida: null,
            horario_saida_prevista: null,
            horario_chegada: null,
            horario_chegada_prevista: null,
            escalonamento: null,
            id_sentido: null,
            descricao_sentido: null,
            id_turno: null,
            descricao_turno: null,
            id_viagem_realizada: null,
            horario_saida_realizada: null,
            horario_chegada_realizada: null,
            id_veiculo: null,
            numero_ordem: null,
            id_motorista_validador: null,
            nome_motorista_validador: null,
            id_cobrador_validador: null,
            nome_cobrador_validador: null,
            id_linha: null,
            cod_linha: null,
            status: null,
            status_extenso: null,
            id_guia: null,
            guia_original: null,
            id_funcionario_motorista: null,
            nome_motorista: null,
            matricula_motorista: null,
            id_funcionario_cobrador: null,
            nome_cobrador: null,
            matricula_cobrador: null,
            dt_abertura_manual: null,
            id_usuario_abertura_manual: null,
            dt_fechamento_manual: null,
            id_usuario_fechamento_manual: null,
            dt_associacao_manual: null,
            id_usuario_associacao_manual: null,
            id_cerca_inicio: null,
            nome_cerca_inicio: null,
            cod_cerca_inicio: null,
            id_cerca_fim: null,
            nome_cerca_fim: null,
            cod_cerca_fim: null,
            dt_referencia: null,
            id_sublinha: null,
            nome_linha: null,
            id_guia_realizada: null,
            id_classificacao: null,
        },
        defaultViagem: {
            id_viagem_grid: null,
            id_viagem_prevista: null,
            horario_saida: null,
            horario_saida_prevista: null,
            horario_chegada: null,
            horario_chegada_prevista: null,
            escalonamento: null,
            id_sentido: null,
            descricao_sentido: null,
            id_turno: null,
            descricao_turno: null,
            id_viagem_realizada: null,
            horario_saida_realizada: null,
            horario_chegada_realizada: null,
            id_veiculo: null,
            numero_ordem: null,
            id_motorista_validador: null,
            nome_motorista_validador: null,
            id_cobrador_validador: null,
            nome_cobrador_validador: null,
            id_linha: null,
            cod_linha: null,
            status: null,
            status_extenso: null,
            id_guia: null,
            guia_original: null,
            id_funcionario_motorista: null,
            nome_motorista: null,
            matricula_motorista: null,
            id_funcionario_cobrador: null,
            nome_cobrador: null,
            matricula_cobrador: null,
            dt_abertura_manual: null,
            id_usuario_abertura_manual: null,
            dt_fechamento_manual: null,
            id_usuario_fechamento_manual: null,
            dt_associacao_manual: null,
            id_usuario_associacao_manual: null,
            id_cerca_inicio: null,
            nome_cerca_inicio: null,
            cod_cerca_inicio: null,
            id_cerca_fim: null,
            nome_cerca_fim: null,
            cod_cerca_fim: null,
            dt_referencia: null,
            id_sublinha: null,
            nome_linha: null,
            id_guia_realizada: null,
            id_classificacao: null,
        },
        dtiPosicoes: null,
        dtfPosicoes: null,
        idVeiculoSelected: null,
        idLinhaAssociada: null,
        formValidadoEditarViagem: false,
        formValidadoDetalhesViagem: false,
        isVeiculoSelectDisabled: false,
        isLinhaDisabled: false,
        isSentidoDisabled: false,
        isEscalonamentoDisabled: true,
        isHorarioSaidaDisabled: false,
        isHorarioChegadaDisabled: false,
        isCercaInicioDisabled: false,
        isCercaFimDisabled: false,
        isMotivoAberturaDisabled: false,
        isObservacoesAberturaDisabled: false,
        isMotivoFechamentoDisabled: false,
        isObservacoesFechamentoDisabled: false,
        classificacaoDisabled: false,
        key: 0,
        posicaoSelected: null,
        showCercas: true,
        showRota: true,
        posicoes: [],
        rotas: [],
        cercasGeojson: [],
        cercasCirculares: [],
        horarioSaidaRealizada: null,
        horarioChegadaRealizada: null,
        idMotivoAbertura: null,
        observacoesAbertura: '',
        idMotivoFechamento: null,
        observacoesFechamento: '',
        motivoConciliacaoManual: null,
        observacoesConciliacaoManual: '',
        motivos: [],
        guias: [],
        editedFechamento: {
            id_fechamento: null,
            id_linha: null,
            observacoes: null,
        },
        defaultFechamento: {
            id_fechamento: null,
            id_linha: null,
            observacoes: null,
        },
        formValidadoFechamentoDia: false,
        dialogFechamentoDia: false,
        idLinhaFiltered: null,
        editedIndexViagem: -1,
        // Fechamento financeiro do dia (subsídio). Só aparece para quem tem a permissão.
        recursos: [],
        fechamentoDiaFinanceiro: null,
        fechamentoMesDoDia: null,
        statusDiaFinanceiroChave: null,
        salvandoFechamentoDiaFinanceiro: false,
        dialogFecharDiaFinanceiro: false,
        dialogReabrirDiaFinanceiro: false,
        observacoesFechamentoDiaFinanceiro: "",
        motivoReaberturaDiaFinanceiro: "",
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaRecursos();
        this.initialize();
        this.dtreferencia = new Date().toISOString().substring(0, 10);
    },
    mounted() {
        this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
    },
    computed: {
        /**
         * A tela toda é de um único dia operacional (dtreferencia), então ou o dia está
         * num mês fechado — e nada nele pode ser alterado — ou está aberto.
         */
        diaEmMesFechado() {
            return !!this.fechamentoDaDtReferencia(this.dtreferencia, this.idEmpresaSelected);
        },
        avisoMesFechadoDia() {
            const f = this.fechamentoDaDtReferencia(this.dtreferencia, this.idEmpresaSelected);
            if (!f) return '';
            return this.$t('closingMonth.editBlockedBanner', { meses: f.periodo_extenso || f.mes_referencia_extenso });
        },
        podeFecharDiaFinanceiro() {
            if (this.user && this.user.is_superadmin === 1) return true;
            return this.recursos.some((r) => r.rota === '/api/v1.0/subsidio/insertfechamentodiafinanceiro');
        },
        podeReabrirDiaFinanceiro() {
            if (this.user && this.user.is_superadmin === 1) return true;
            return this.recursos.some((r) => r.rota === '/api/v1.0/subsidio/reabrirfechamentodiafinanceiro');
        },
        /**
         * Se o status financeiro já foi carregado para a empresa/dia selecionados agora. É o que
         * autoriza fechar, para o usuário não encerrar um dia diferente do que consultou.
         */
        statusDiaFinanceiroCarregado() {
            return this.statusDiaFinanceiroChave != null &&
                this.statusDiaFinanceiroChave === `${this.idEmpresaSelected}|${this.dtreferencia}`;
        },
        /** Só dias já encerrados podem ser fechados: o dia de hoje ainda recebe viagens. */
        diaEncerrado() {
            if (!this.dtreferencia) return false;
            const d = new Date();
            const pad = (n) => String(n).padStart(2, '0');
            return this.dtreferencia < `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        },
        resumoFechamentoDiaFinanceiro() {
            const f = this.fechamentoDiaFinanceiro;
            if (!f) return '';
            return this.$t('closingDay.closedBanner', {
                data: this.formatDataHora(f.dt_fechamento),
                usuario: f.nome_usuario_fechamento || '-',
                viagens: f.qtd_viagens != null ? f.qtd_viagens : 0,
            });
        },
        dtReferenciaFormatada() {
            if (this.dtreferencia) {
                const year = this.dtreferencia.substring(0, 4);
                const month = this.dtreferencia.substring(5, 7);
                const day = this.dtreferencia.substring(8, 10);
                return `${day}/${month}/${year}`;
            }

            return null;
        },
        dtiProps() {
            return {
                max: this.today,
                rules: [this.dtRules]
            }
        },
        dtfProps() {
            return {
                min: this.dti,
                rules: [this.dtRules]
            }
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtRules() {
            return [(v) => !!v || this.$t('contract.messages.selectDate')];
        },
        selectedLinha() {
            if (this.idLinhaAssociada && this.linhas.length > 0) {
                return this.linhas.find(l => l.id_linha === this.idLinhaAssociada);
            }
            return null;
        },
        guiasSelect() {
            return this.guias.filter(g => g.id_linha === this.idLinhaAssociada && g.id_veiculo === this.idVeiculoSelected);
        },
        viagensFiltered() {
            if (this.idLinhaFiltered) {
                return this.viagens.filter(v => v.id_linha === this.idLinhaFiltered);
            }

            return this.viagens;
        },
        embarquesFiltered() {
            if (this.idLinhaFiltered) {
                return this.embarques.filter(e => e.id_linha === this.idLinhaFiltered);
            }

            return this.embarques;
        },
        viagensParaAssociacao() {
            return this.viagensFiltered
                .filter(v =>
                    v.id_fechamento_dia == null &&
                    Number(v.is_viagem_invalida) !== 1 &&
                    v.horario_saida_realizada &&
                    v.horario_chegada_realizada
                )
                .map(v => ({
                    ...v,
                    label_busca: [
                        v.cod_linha,
                        v.numero_ordem_veiculo_realizado,
                        v.descricao_sentido,
                        v.horario_saida_realizada_extenso,
                        v.horario_chegada_realizada_extenso,
                        v.motorista_realizado,
                    ].filter(Boolean).join(' '),
                }));
        },
        headersEmbarques() {
            return [
                { text: this.$t('fechamentoDia.embarques.headers.datetime'), value: 'dt_embarque_extenso', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.embarques.headers.passenger'), value: 'nome_completo', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.embarques.headers.registration'), value: 'matricula', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.embarques.headers.line'), value: 'cod_linha_veiculo', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.embarques.headers.vehicle'), value: 'numero_ordem', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.embarques.headers.stop'), value: 'nome_cerca', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.embarques.headers.authorized'), value: 'autorizado_extenso', sortable: true, filtrable: true },
            ];
        },
        headers() {
            return [
                { text: this.$t('fechamentoDia.headers.status'), value: 'flag_viagem_a_conferir', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headers.id'), value: 'id_viagem_grid', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headers.tripClassification'), value: 'descricao_classificacao', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headers.line'), value: 'cod_linha', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headers.escalation'), value: 'escalonamento_viagem', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headers.vehicle'), value: 'numero_ordem_veiculo_realizado', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headers.driver'), value: 'motorista_realizado', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headers.direction'), value: 'descricao_sentido', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headers.shift'), value: 'descricao_turno', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headers.departure'), value: 'horario_saida', align: ' d-none', sortable: true, filtrable: false },
                { text: this.$t('fechamentoDia.headers.departureExpected'), value: 'horario_saida_prevista', align: ' d-none', sortable: true, filtrable: false },
                { text: this.$t('fechamentoDia.headers.departureExpectedExtenso'), value: 'horario_saida_prevista_extenso', sortable: false, filtrable: true },
                { text: this.$t('fechamentoDia.headers.departureRealized'), value: 'horario_saida_realizada_extenso', sortable: false, filtrable: true },
                { text: this.$t('fechamentoDia.headers.arrival'), value: 'horario_chegada_realizada', align: ' d-none', sortable: true, filtrable: false },
                { text: this.$t('fechamentoDia.headers.arrivalExpected'), value: 'horario_chegada_prevista', align: ' d-none', sortable: true, filtrable: false },
                { text: this.$t('fechamentoDia.headers.arrivalExpectedExtenso'), value: 'horario_chegada_prevista_extenso', sortable: false, filtrable: true },
                { text: this.$t('fechamentoDia.headers.arrivalRealized'), value: 'horario_chegada_realizada', align: ' d-none', sortable: true, filtrable: false },
                { text: this.$t('fechamentoDia.headers.arrivalRealizedExtenso'), value: 'horario_chegada_realizada_extenso', sortable: false, filtrable: true },
                { text: this.$t('fechamentoDia.headers.openingManual'), value: 'dt_abertura_manual', align: ' d-none', sortable: true, filtrable: false },
                { text: this.$t('fechamentoDia.headers.openingManualExtenso'), value: 'dt_abertura_manual_extenso', sortable: false, filtrable: true },
                { text: this.$t('fechamentoDia.headers.closingManual'), value: 'dt_fechamento_manual', align: ' d-none', sortable: true, filtrable: false },
                { text: this.$t('fechamentoDia.headers.closingManualExtenso'), value: 'dt_fechamento_manual_extenso', sortable: false, filtrable: true },
                { text: this.$t('fechamentoDia.headers.actions'), value: 'actions', sortable: false, filtrable: false }]
        },
        headersLinhas() {
            return [
                { text: this.$t('fechamentoDia.headersLinhas.status'), value: 'status_linha', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headersLinhas.line'), value: 'cod_linha', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headersLinhas.expectedDepartures'), value: 'n_horarios_previstos', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headersLinhas.realizedDepartures'), value: 'n_viagens_realizadas', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headersLinhas.completedDepartures'), value: 'n_horarios_cumpridos', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headersLinhas.expectedDeparturesProductive'), value: 'n_horarios_previstos_produtivos', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headersLinhas.realizedDeparturesProductive'), value: 'n_viagens_realizadas_produtivas', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headersLinhas.completedDeparturesProductive'), value: 'n_horarios_previstos_produtivos_cumpridos', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headersLinhas.closingDate'), value: 'dt_fechamento_dia_extenso', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headersLinhas.closingBy'), value: 'usuario_fechamento', sortable: true, filtrable: true },
                { text: this.$t('fechamentoDia.headersLinhas.actions'), value: 'actions', sortable: false, filtrable: false }]
        },
        defaultMultiSort(){
            return [
                { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } },
                { value: 'horario_saida', options: { text: this.$t('system.labels.increasing'), value: 1 } }]
        },
        defaultMultiSortLinhas(){
            return [
                { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } }]
        },
        defaultMultiSortEmbarques(){
            return [
                { value: 'dt_embarque_extenso', options: { text: this.$t('system.labels.increasing'), value: 1 } },
            ]
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
            }
        },
    },
    watch: {
        idLinhaAssociada() {
            if (this.idLinhaAssociada) {
                this.populaMapa();
            }
        },
    },
    methods: {
        initialize() {
            this.getConfig();
            this.populaVeiculos();
            this.populaSentidos();
            this.populaMotivos();
            this.populaClassificacoes();
        },
        buscaFechamentoDia() {
            // Períodos fechados da empresa, para avisar e bloquear a edição do dia congelado.
            this.carregaFechamentosMesAtivos(this.idEmpresaSelected);
            this.carregaFechamentoDiaFinanceiro();
            this.populaLinhas();
            this.populaViagens();
            this.populaEmbarques();
            this.populaGuias();
        },
        getIntervaloDiaOperacao() {
            let dtReferenciaDate = new Date(this.dtreferencia + 'T00:00:00');
            const horaInicial = this.config?.hora_inicial_dia_operacao || '03:00';
            const [hora, minuto] = horaInicial.split(':').map(Number);
            dtReferenciaDate.setHours(hora, minuto, 0, 0);
            const dti = DateUtils.getDateSQLFormatted(dtReferenciaDate);
            const dtfDate = new Date(dtReferenciaDate);
            dtfDate.setDate(dtfDate.getDate() + 1);
            const dtf = DateUtils.getDateSQLFormatted(dtfDate);
            return { dti, dtf };
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                silent: true,
                onSuccess: (response) => {
                    this.config = response.data[0];
                },
                onError: (error) => {
                    console.log(error);
                },
            });
        },
        applySingleEmpresaIfOnlyOption() {
            if (this.idEmpresaSelected != null && this.idEmpresaSelected !== '') {
                return;
            }
            apiController.request(apiController.endpoints.getEmpresaslazy, {
                data: {
                    page: 1,
                    pageSize: 2,
                    search: '',
                    showInactives: false,
                },
                silent: true,
                onSuccess: (response) => {
                    const items = response.data?.items || [];
                    if (items.length !== 1) {
                        return;
                    }
                    const empresa = items[0];
                    const idEmpresa = empresa.id_empresa;
                    this.idEmpresaSelected = idEmpresa;
                    this.$nextTick(() => {
                        const ref = this.$refs.empresaSelect;
                        if (!ref) {
                            return;
                        }
                        ref.cacheSelectedItems?.([empresa], 'id_empresa');
                        ref.setSelectedItem?.(idEmpresa);
                        ref.loadLazyItems?.('');
                    });
                },
                onError: (error) => {
                    console.log(error);
                },
            });
        },
        populaClassificacoes() {
            apiController.request(apiController.endpoints.getallClassificacoes, {
                silent: true,
                onSuccess: (response) => {
                    this.classificacoes = response.data;
                },
                onError: (error) => {
                    console.log(error);
                },
            });
        },
        async populaViagens() {
            this.loading = true;
            try {
                const response = await apiController.request(apiController.endpoints.getViagensfechamentodia, {
                    data: {
                        idEmpresa: this.idEmpresaSelected,
                        idUnidade: this.idUnidadeSelected,
                        dtReferencia: this.dtreferencia,
                    },
                    silent: true,
                });
                this.viagens = response.data;
                this.loading = false;
                return response.data;
            } catch (error) {
                this.loading = false;
                console.log(error);
                throw error;
            }
        },
        populaEmbarques() {
            if (!this.dtreferencia) {
                return;
            }

            this.loadingEmbarques = true;
            const { dti, dtf } = this.getIntervaloDiaOperacao();

            apiController.request(apiController.endpoints.getEmbarquesnaoassociadosfechamentodia, {
                data: {
                    idEmpresa: this.idEmpresaSelected,
                    idUnidade: this.idUnidadeSelected,
                    dti,
                    dtf,
                },
                silent: true,
                onSuccess: (response) => {
                    this.embarques = response.data || [];
                    this.embarquesSelected = [];
                    this.loadingEmbarques = false;
                },
                onError: (error) => {
                    this.loadingEmbarques = false;
                    console.log(error);
                },
            });
        },
        async populaLinhas() {
            this.loadingLinhas = true;
            try {
                const response = await apiController.request(apiController.endpoints.getLinhasfechamentodia, {
                    data: {
                        idEmpresa: this.idEmpresaSelected,
                        idUnidade: this.idUnidadeSelected,
                        dtReferencia: this.dtreferencia,
                    },
                    silent: true,
                });
                this.linhas = response.data;
                this.loadingLinhas = false;
                return response.data;
            } catch (error) {
                this.loadingLinhas = false;
                console.log(error);
                throw error;
            }
        },
        populaVeiculos() {
            apiController.request(apiController.endpoints.getallVeiculos, {
                silent: true,
                onSuccess: (response) => {
                    this.veiculos = response.data;
                },
                onError: (error) => {
                    console.log(error);
                },
            });
        },
        populaSentidos() {
            apiController.request(apiController.endpoints.getallSentidos, {
                silent: true,
                onSuccess: (response) => {
                    this.sentidos = response.data;
                },
                onError: (error) => {
                    console.log(error);
                },
            });
        },
        populaMotivos() {
            apiController.request(apiController.endpoints.getallMotivos, {
                silent: true,
                onSuccess: (response) => {
                    this.motivos = response.data;
                },
                onError: (error) => {
                    console.log(error);
                },
            });
        },
        populaGuias() {
            const { dti, dtf } = this.getIntervaloDiaOperacao();

            apiController.request(apiController.endpoints.getGuiasdata, {
                params: { dti, dtf },
                silent: true,
                onSuccess: (response) => {
                    this.guias = response.data;
                },
                onError: (error) => {
                    console.log(error);
                },
            });
        },
        closeDialogEditarViagem() {
            this.dialogUpdateViagem = false;
            this.editedViagem = Object.assign({}, this.defaultViagem);
            this.editedIndexViagem = -1;
            this.isVeiculoSelectDisabled = false;
            this.idVeiculoSelected = null;
            this.dtiPosicoes = null;
            this.dtfPosicoes = null;
            this.horarioSaidaRealizada = null;
            this.horarioChegadaRealizada = null;
            this.posicoes = [];
            this.rotas = [];
            this.cercas = [];
            this.cercasCirculares = [];
            this.cercasGeojson = [];
            this.posicaoSelected = null;
            this.mapaPopulado = false;
            this.atualizadoPelaPosicao = false;
            this.idLinhaAssociada = null;
            this.idMotivoAbertura = null;
            this.observacoesAbertura = null;
            this.idMotivoFechamento = null;
            this.observacoesFechamento = null;
            this.motivoConciliacaoManual = null;
            this.observacoesConciliacaoManual = '';
            // Limpar cache de ícones
            if (this._iconCache) {
                this._iconCache = {};
            }
            // Refs (pickers, forms) live inside UpdateViagemDialog; dialog clears its own state on close
            const dialogRef = this.$refs.updateViagemDialog;
            if (dialogRef && dialogRef.$refs) {
                dialogRef.$refs.horarioSaidaRealizadaPicker?.clearHandler?.();
                dialogRef.$refs.horarioChegadaRealizadaPicker?.clearHandler?.();
                dialogRef.$refs.dtiPosicoesPicker?.clearHandler?.();
                dialogRef.$refs.dtfPosicoesPicker?.clearHandler?.();
                dialogRef.$refs.formEditarViagem?.resetValidation?.();
                dialogRef.$refs.formDetalhesViagem?.resetValidation?.();
            }
        },
        onViagemUpdated() {
            this.refreshRelatorioViagens();
        },
        onViagemRevalidated(viagem) {
            if (viagem && viagem.id_viagem_grid != null) {
                this.aplicarRevalidacaoLocal(viagem);
            }
            this.refreshRelatorioViagens();
        },
        async refreshRelatorioViagens() {
            this.displayedViagensItemsForExport = null;
            this.displayedLinhasItemsForExport = null;
            try {
                await Promise.all([this.populaViagens(), this.populaLinhas()]);
                this.closeDialogEditarViagem();
            } catch (error) {
                console.log(error);
            }
        },
        aplicarRevalidacaoLocal(viagem) {
            const idx = this.viagens.findIndex(v => v.id_viagem_grid === viagem.id_viagem_grid);
            if (idx === -1) {
                return;
            }

            const atual = this.viagens[idx];
            const atualizada = {
                ...atual,
                ...viagem,
                is_viagem_invalida: 0,
            };

            if (!atualizada.descricao_status || atualizada.descricao_status === 'Viagem Inválida') {
                atualizada.descricao_status = this.inferirDescricaoStatusViagem(atualizada);
            }

            const horariosCompletos = atualizada.horario_saida_prevista &&
                atualizada.horario_saida_realizada &&
                atualizada.horario_chegada_prevista &&
                atualizada.horario_chegada_realizada;
            if (horariosCompletos && Number(atualizada.flag_viagem_a_conferir) === 1) {
                atualizada.flag_viagem_a_conferir = 0;
            }

            this.$set(this.viagens, idx, atualizada);

            if (this.editedViagem && this.editedViagem.id_viagem_grid === viagem.id_viagem_grid) {
                this.editedViagem = Object.assign({}, atualizada);
            }
        },
        inferirDescricaoStatusViagem(viagem) {
            if (viagem.id_fechamento_dia != null) {
                return 'Dia Fechado';
            }
            if (viagem.horario_saida_prevista && !viagem.horario_saida_realizada &&
                viagem.horario_chegada_prevista && !viagem.horario_chegada_realizada) {
                return 'Horário Previsto Não Cumprido';
            }
            if ((viagem.horario_saida_realizada && !viagem.horario_chegada_realizada) ||
                (!viagem.horario_saida_realizada && viagem.horario_chegada_realizada)) {
                return 'Viagem Incompleta';
            }
            if (!viagem.horario_saida_prevista && viagem.horario_saida_realizada &&
                !viagem.horario_chegada_prevista && viagem.horario_chegada_realizada) {
                return 'Viagem Fora de Horário Previsto';
            }
            return 'Horário Cumprido';
        },
        isViagemInvalida(item) {
            return Number(item?.is_viagem_invalida) === 1;
        },
        getViagemRowClass(item) {
            if (this.isViagemInvalida(item)) {
                return 'fechamento-dia__viagem-invalida';
            }
            return '';
        },
        openDialogEditarViagem(item) {
            if (item) {
                this.editedViagem = Object.assign({}, item);
                this.idLinhaAssociada = item.id_linha;
                this.horarioSaidaRealizada = item.horario_saida_realizada ? new Date(item.horario_saida_realizada) : null;
                this.horarioChegadaRealizada = item.horario_chegada_realizada ? new Date(item.horario_chegada_realizada) : null;
                this.dtiPosicoes = new Date(item.horario_saida);
                this.dtfPosicoes = new Date(item.horario_chegada);
                this.idMotivoAbertura = item.id_motivo_abertura_manual;
                this.observacoesAbertura = item.observacoes_abertura_manual;
                this.idMotivoFechamento = item.id_motivo_fechamento_manual;
                this.observacoesFechamento = item.observacoes_fechamento_manual;
                this.idVeiculoSelected = item.id_veiculo_realizado;
                this.isVeiculoSelectDisabled = !!item.id_veiculo_realizado;
                this.editedIndexViagem = this.viagens.indexOf(item);
                this.key = this.key == 0 ? 1 : 0;
                this.dialogUpdateViagem = true;
                if (item.horario_saida_realizada && item.horario_chegada_realizada) {
                    const camposValidos = this.idVeiculoSelected &&
                        this.idLinhaAssociada &&
                        this.editedViagem.id_sentido &&
                        this.dtiPosicoes &&
                        this.dtfPosicoes;
                    this.$nextTick(() => { this.populaMapa(camposValidos); });
                }
            } else {
                this.dialogUpdateViagem = true;
            }
        },
        async populaMapa(bypassValidation = false) {
            if (this.$refs.formEditarViagem) {
                this.$refs.formEditarViagem.validate();
            }

            if (this.formValidadoEditarViagem || bypassValidation) {
                this.mapaPopulado = true;
                this.populaPosicoes();
                this.populaRotas();
                this.populaCercas();
            }
        },
        async populaPosicoes() {
            this.loadingPosicoes = true;
            const payload = {
                id: this.idVeiculoSelected,
                dti: DateUtils.getDateSQLFormatted(this.dtiPosicoes),
                dtf: DateUtils.getDateSQLFormatted(this.dtfPosicoes)
            }
            const response = await apiController.request(apiController.endpoints.getPosicoesporcarrodata, { data: payload, silent: true });

            if (response.status !== 200) {
                console.log(response.data);
                this.loadingPosicoes = false;
                return [];
            }

            if (response.data.error) {
                console.log(response.data);
                return [];
            }

            this.loadingPosicoes = false;
            this.posicoes = response.data;
            if (this.posicoes.length > 0) {
                this.currentCenter = [this.posicoes[0].lat, this.posicoes[0].lng];
            }
        },
        async populaRotas() {
            const response = await apiController.request(apiController.endpoints.getRotasporlinha, { data: [this.idLinhaAssociada], silent: true });

            if (response.status !== 200) {
                console.log(response.data);
                return [];
            }

            if (response.data.error) {
                console.log(response.data);
                return [];
            }

            let rotas = response.data;
            if (rotas.length > 0) {
                this.rotas = rotas.filter((rota) => rota.id_sentido == this.editedViagem.id_sentido).map((rota) => {
                    rota.geojson = JSON.parse(rota.geojson);
                    return rota;
                });
            }
        },
        async populaCercas() {
            const response = await apiController.request(apiController.endpoints.getCercasporlinha, { data: [this.idLinhaAssociada], silent: true });

            if (response.status !== 200) {
                console.log(response.data);
                return [];
            }

            if (response.data.error) {
                console.log(response.data);
                return [];
            }

            let cercas = response.data;
            if (cercas.length > 0) {
                this.cercas = cercas.map((cerca) => {
                    let color = cerca.id_tipo_cerca == 2 || cerca.id_tipo_cerca == 3 ? "#43A047" : "#4287f5";
                    cerca.style = {
                        color: color,
                        weight: 1,
                        fillColor: color,
                        fillOpacity: 0.3
                    };
                    cerca.geojson = JSON.parse(cerca.geojson);
                    // Add onEachFeature for non-circular stops to show tooltips
                    if (cerca.is_circular == 0) {
                        cerca.options = {
                            onEachFeature: (feature, layer) => {
                                if (cerca.nome_cerca) {
                                    layer.bindTooltip(cerca.nome_cerca);
                                }
                            }
                        };
                    }
                    return cerca;
                });
                this.cercasCirculares = this.cercas.filter((cerca) => cerca.is_circular == 1);
                this.cercasGeojson = this.cercas.filter((cerca) => cerca.is_circular == 0);
            }
        },
        onMapReady() {
            this.map = this.$refs.map.mapObject;
            this.currentCenter = [this.center[0], this.center[1]];
            this.onMapResize();
        },
        onMapResize() {
            this.$refs.map.mapObject.invalidateSize();
        },
        showDetalhesPosicoes(k) {
            const posicao = this.posicoes[k];
            // Usar comparação estrita e evitar atribuição desnecessária
            if (this.posicaoSelected?.dt_posicao === posicao.dt_posicao) {
                this.posicaoSelected = null;
            } else {
                this.posicaoSelected = posicao;
            }
        },
        getIconPosicao(reg) {
            const isSelected = this.posicaoSelected && reg.dt_posicao === this.posicaoSelected.dt_posicao;
            const color = isSelected ? "green" : "#4A4A4A";

            // Cache de ícones para evitar recriação desnecessária
            if (!this._iconCache) {
                this._iconCache = {};
            }

            if (!this._iconCache[color]) {
                this._iconCache[color] = L.divIcon({
                    className: "my-custom-pin",
                    html: `<svg width="20" height="20" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.1" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" fill="${color}"/>
                            <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="${color}" stroke-width="2"/>
                            <path d="M15 13L12.2014 10.2014V10.2014C12.0901 10.0901 11.9099 10.0901 11.7986 10.2014V10.2014L9 13" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>`,
                    iconAnchor: [15, 15]
                });
            }

            return this._iconCache[color];
        },
        latLng(lat, lng) {
            if (lat != null && lng !== null) {
                if (lat.trim() !== "0") {
                    return L.latLng(lat, lng);
                } else {
                    return L.latLng(this.center[0], this.center[1]);
                }
            } else {
                return L.latLng(this.center[0], this.center[1]);
            }
        },
        // async getHodometro() {
        //     const payload = {
        //         idveiculo: this.editedViagem.id_veiculo_realizado,
        //         dti: this.editedViagem.horario_saida_realizada,
        //         dtf: this.editedViagem.horario_chegada_realizada
        //     }
        //     const response = await axios
        //         .post(ApiBaseUrl + "/api/v1.0/gethodometrokmcarro", payload, {
        //             headers: { "x-access-token": this.token },
        //         });

        //     if (response.status !== 200) {
        //         EventBus.$emit('show-error', { error: { response, status: response.status } });
        //         return [];
        //     }

        //     if (response.data.error) {
        //         EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
        //         return [];
        //     }

        //     return response.data;
        // },
        atualizarViagem(tipo) {
            if (tipo == 1) {
                this.editedViagem.horario_saida_realizada = this.posicaoSelected ? DateUtils.getDateSQLFormatted(new Date(this.posicaoSelected?.dt_posicao)) : DateUtils.getDateSQLFormatted(new Date(this.horarioSaidaRealizada));
                this.editedViagem.horario_saida_realizada_extenso = this.editedViagem.horario_saida_realizada.substring(11, 16);
                this.horarioSaidaRealizada = new Date(this.editedViagem.horario_saida_realizada);
                this.editedViagem.dt_abertura_manual = DateUtils.getDateSQLFormatted(new Date());
                this.editedViagem.dt_abertura_manual_extenso = new Date().toLocaleString();
                this.editedViagem.id_usuario_abertura_manual = this.user.id_usuario;
                this.editedViagem.tipo_abertura = "Manual";
            } else {
                this.editedViagem.horario_chegada_realizada = this.posicaoSelected ? DateUtils.getDateSQLFormatted(new Date(this.posicaoSelected?.dt_posicao)) : DateUtils.getDateSQLFormatted(new Date(this.horarioChegadaRealizada));
                this.editedViagem.horario_chegada_realizada_extenso = this.editedViagem.horario_chegada_realizada.substring(11, 16);
                this.horarioChegadaRealizada = new Date(this.editedViagem.horario_chegada_realizada);
                this.editedViagem.dt_fechamento_manual = DateUtils.getDateSQLFormatted(new Date());
                this.editedViagem.dt_fechamento_manual_extenso = new Date().toLocaleString();
                this.editedViagem.id_usuario_fechamento_manual = this.user.id_usuario;
                this.editedViagem.tipo_fechamento = "Manual";
            }

            this.posicaoSelected = null;
            this.atualizadoPelaPosicao = true;
        },
        async updateViagemGrid() {
            this.$refs.formDetalhesViagem.validate();
            if (this.formValidadoDetalhesViagem) {
                if (!this.atualizadoPelaPosicao) {
                    this.atualizarViagem(1);
                    this.atualizarViagem(2);
                }

                if (this.editedViagem.id_cerca_inicio && !this.editedViagem.nome_cerca_inicio) {
                    let cercaInicio = this.cercas.find((cerca) => cerca.id_cerca == this.editedViagem.id_cerca_inicio);
                    this.editedViagem.nome_cerca_inicio = cercaInicio?.nome_cerca;
                    this.editedViagem.cod_cerca_inicio = cercaInicio?.cod_cerca;
                }

                if (this.editedViagem.id_cerca_fim && !this.editedViagem.nome_cerca_fim) {
                    let cercaFim = this.cercas.find((cerca) => cerca.id_cerca == this.editedViagem.id_cerca_fim);
                    this.editedViagem.nome_cerca_fim = cercaFim?.nome_cerca;
                    this.editedViagem.cod_cerca_fim = cercaFim?.cod_cerca;
                }

                if (this.idLinhaAssociada != this.editedViagem.id_linha || this.editedViagem.id_linha == null) {
                    const linhaAssociada = this.linhas.find((linha) => linha.id_linha == this.idLinhaAssociada);
                    this.editedViagem.id_linha_associada = this.idLinhaAssociada;
                    this.editedViagem.cod_linha_associada = linhaAssociada.cod_linha;
                    this.editedViagem.dt_associacao_manual = DateUtils.getDateSQLFormatted(new Date());
                    this.editedViagem.id_usuario_associacao_manual = this.user.id_usuario;
                    if (this.editedViagem.id_linha == null) {
                        this.editedViagem.id_linha = this.idLinhaAssociada;
                        this.editedViagem.cod_linha = linhaAssociada.cod_linha;
                    }
                }

                if (this.editedViagem.id_veiculo_realizado != this.idVeiculoSelected || this.editedViagem.id_veiculo_realizado == null) {
                    const veiculoAssociado = this.veiculos.find((veiculo) => veiculo.id_veiculo == this.idVeiculoSelected);
                    this.editedViagem.id_veiculo_realizado = this.idVeiculoSelected;
                    this.editedViagem.numero_ordem_veiculo_realizado = veiculoAssociado.numero_ordem;
                }

                // Verificar mudanças no motivo de abertura
                if (this.idMotivoAbertura !== this.editedViagem.id_motivo_abertura_manual ||
                    this.observacoesAbertura !== this.editedViagem.observacoes_abertura_manual) {
                    this.editedViagem.id_motivo_abertura_manual = this.idMotivoAbertura;
                    this.editedViagem.observacoes_abertura_manual = this.observacoesAbertura;
                    if (this.idMotivoAbertura) {
                        const idEntrada = await this.insertEntradaDiario(this.idMotivoAbertura, this.observacoesAbertura);
                        await this.insertEntradaLinhas(idEntrada, this.editedViagem.id_linha);
                        await this.insertEntradaVeiculos(idEntrada, this.editedViagem.id_veiculo_realizado);
                    }
                }

                // Verificar mudanças no motivo de fechamento
                if (this.idMotivoFechamento !== this.editedViagem.id_motivo_fechamento_manual ||
                    this.observacoesFechamento !== this.editedViagem.observacoes_fechamento_manual) {
                    this.editedViagem.id_motivo_fechamento_manual = this.idMotivoFechamento;
                    this.editedViagem.observacoes_fechamento_manual = this.observacoesFechamento;
                    if (this.idMotivoFechamento) {
                        const idEntrada = await this.insertEntradaDiario(this.idMotivoFechamento, this.observacoesFechamento);
                        await this.insertEntradaLinhas(idEntrada, this.editedViagem.id_linha);
                        await this.insertEntradaVeiculos(idEntrada, this.editedViagem.id_veiculo_realizado);
                    }
                }

                // let hodometro = await this.getHodometro();

                // if (hodometro.length > 0) {
                //     const hodometroInicial = hodometro[0].hodometro_can_inicial > 0 ? hodometro[0].hodometro_can_inicial : hodometro[0].hodometro_virtual_inicial
                //     const dtHodometroInicial = hodometro[0].hodometro_can_inicial > 0 ? hodometro[0].dt_hodometro_can_inicial : hodometro[0].dt_hodometro_virtual_inicial;
                //     const hodometroFinal = hodometro[0].hodometro_can_final > 0 ? hodometro[0].hodometro_can_final : hodometro[0].hodometro_virtual_final;
                //     const dtHodometroFinal = hodometro[0].hodometro_can_final > 0 ? hodometro[0].dt_hodometro_can_final : hodometro[0].dt_hodometro_virtual_final;
                //     this.editedViagem.hodometro_inicial = hodometroInicial;
                //     this.editedViagem.dt_hodometro_inicial = dtHodometroInicial;
                //     this.editedViagem.hodometro_final = hodometroFinal;
                //     this.editedViagem.dt_hodometro_final = dtHodometroFinal;
                //     this.editedViagem.km_aferido = hodometroFinal - hodometroInicial;
                // }

                const linha = this.linhas.find((linha) => linha.id_linha == this.editedViagem.id_linha || linha.id_linha == this.idLinhaAssociada);
                const guia = this.guias.find((guia) => guia.id_guia == this.editedViagem.id_guia_realizada);
                this.editedViagem.km_nominal = this.editedViagem.id_sentido == 1 ? linha.distancia_ida : linha.distancia_volta;

                let payload = {
                    id_viagem_realizada: this.editedViagem.id_viagem_realizada,
                    id_guia: this.editedViagem.id_guia_realizada,
                    id_linha: this.editedViagem.id_linha,
                    cod_linha: this.editedViagem.cod_linha,
                    id_sentido: this.editedViagem.id_sentido,
                    id_turno: this.editedViagem.id_turno || guia?.turno,
                    numero_guia: this.editedViagem.numero_guia_realizada || guia?.guia_original,
                    id_veiculo: this.editedViagem.id_veiculo_realizado,
                    numero_ordem: this.editedViagem.numero_ordem_veiculo_realizado,
                    dt_inicio: this.editedViagem.horario_saida_realizada,
                    dt_fim: this.editedViagem.horario_chegada_realizada,
                    escalonamento: this.editedViagem.escalonamento_veiculo,
                    id_motorista: this.editedViagem.id_motorista_realizado,
                    matricula_motorista: this.editedViagem.matricula_motorista_realizado,
                    nome_motorista: this.editedViagem.nome_motorista_realizado,
                    id_cobrador: this.editedViagem.id_cobrador_realizado,
                    matricula_cobrador: this.editedViagem.matricula_cobrador_realizado,
                    nome_cobrador: this.editedViagem.nome_cobrador_realizado,
                    id_status: this.editedViagem.id_status,
                    hodometro_inicio: this.editedViagem.hodometro_inicial,
                    dt_hodometro_inicio: this.editedViagem.dt_hodometro_inicial,
                    hodometro_fim: this.editedViagem.hodometro_final,
                    dt_hodometro_fim: this.editedViagem.dt_hodometro_final,
                    consumo_inicio: this.editedViagem.consumo_inicial,
                    dt_consumo_inicio: this.editedViagem.dt_consumo_inicial,
                    consumo_fim: this.editedViagem.consumo_final,
                    dt_consumo_fim: this.editedViagem.dt_consumo_final,
                    id_origem: this.editedViagem.id_origem,
                    temp_media: this.editedViagem.temp_media,
                    condicao_climatica: this.editedViagem.condicao_climatica,
                    id_usuario_abertura_manual: this.editedViagem.id_usuario_abertura_manual,
                    dt_abertura_manual: this.editedViagem.dt_abertura_manual,
                    id_usuario_fechamento_manual: this.editedViagem.id_usuario_fechamento_manual,
                    dt_fechamento_manual: this.editedViagem.dt_fechamento_manual,
                    id_usuario_associacao_manual: this.editedViagem.id_usuario_associacao_manual,
                    dt_associacao_manual: this.editedViagem.dt_associacao_manual,
                    tempo_de_placa: this.editedViagem.tempo_de_placa,
                    id_cerca_inicio: this.editedViagem.id_cerca_inicio,
                    cod_cerca_inicio: this.editedViagem.cod_cerca_inicio,
                    nome_cerca_inicio: this.editedViagem.nome_cerca_inicio,
                    id_cerca_fim: this.editedViagem.id_cerca_fim,
                    cod_cerca_fim: this.editedViagem.cod_cerca_fim,
                    nome_cerca_fim: this.editedViagem.nome_cerca_fim,
                    passageiros_totais: this.editedViagem.passageiros_totais,
                    passageiros_pagantes: this.editedViagem.passageiros_pagantes,
                    passageiros_gratuidades: this.editedViagem.passageiros_gratuidades,
                    passageiros_vt: this.editedViagem.passageiros_vt,
                    id_motivo_abertura_manual: this.editedViagem.id_motivo_abertura_manual,
                    id_motivo_fechamento_manual: this.editedViagem.id_motivo_fechamento_manual,
                    observacoes_abertura_manual: this.editedViagem.observacoes_abertura_manual,
                    observacoes_fechamento_manual: this.editedViagem.observacoes_fechamento_manual,
                    id_viagem_grid: this.editedViagem.id_viagem_grid,
                    km_aferido: this.editedViagem.km_aferido,
                    km_nominal: this.editedViagem.km_nominal,
                    id_linha_associada: this.editedViagem.id_linha_associada,
                    cod_linha_associada: this.editedViagem.cod_linha_associada,
                    id_classificacao: this.editedViagem.id_classificacao,
                    processar_viagem: true,
                };

                let response;

                if (this.editedIndexViagem === -1) {
                    const dataInicio = this.editedViagem.horario_saida_realizada

                    const horaInicialConfig = this.config?.hora_inicial_dia_operacao || "03:00";
                    const [horaConfig, minConfig] = horaInicialConfig.split(":").map(Number);

                    const dataInicioComparacao = new Date(dataInicio);
                    dataInicioComparacao.setHours(horaConfig, minConfig, 0, 0);

                    let dtReferenciaDate;
                    if (dataInicio < dataInicioComparacao) {
                        // Subtrai 1 dia
                        dtReferenciaDate = new Date(dataInicio);
                        dtReferenciaDate.setDate(dtReferenciaDate.getDate() - 1);
                    } else {
                        dtReferenciaDate = new Date(dataInicio);
                    }

                    // Formata para yyyymmdd
                    const yyyymmdd = dtReferenciaDate.getFullYear().toString() +
                        String(dtReferenciaDate.getMonth() + 1).padStart(2, '0') +
                        String(dtReferenciaDate.getDate()).padStart(2, '0');

                    payload.dt_referencia = yyyymmdd;

                    response = await apiController.request(apiController.endpoints.insertViagemgrid, { data: payload, silent: true });
                } else {
                    response = await apiController.request(apiController.endpoints.updateViagemgrid, { data: payload, silent: true });
                }

                if (response.status !== 200) {
                    console.log(response.data);
                    return;
                }

                if (response.data.error) {
                    console.log(response.data);
                    return;
                }

                console.log(response.data);

                this.populaViagens();
                this.closeDialogEditarViagem();
            }
        },
        async insertEntradaDiario(idmotivo, observacoes) {
            const payload = {
                id_tipo_entrada_diario: 1,
                id_motivo: idmotivo,
                dt_entrada: DateUtils.getDateSQLFormatted(new Date()),
                id_usuario_inclusao: this.user.id_usuario,
                observacoes: observacoes,
            }

            const response = await apiController.request(apiController.endpoints.insertEntrada, { data: payload, silent: true });

            if (response.status !== 200) {
                console.log(response.data);
                return;
            }

            if (response.data.error) {
                console.log(response.data);
                return;
            }

            return response.data.insertId;
        },
        async insertEntradaLinhas(idEntrada, idLinha) {
            const payload = [[idEntrada, idLinha]];

            const response = await apiController.request(apiController.endpoints.insertLinhasentradabulk, { data: payload, silent: true });

            if (response.status !== 200) {
                console.log(response.data);
                return;
            }

            if (response.data.error) {
                console.log(response.data);
                return;
            }

            return;
        },
        async insertEntradaVeiculos(idEntrada, idVeiculo) {
            const payload = [[idEntrada, idVeiculo]];

            const response = await apiController.request(apiController.endpoints.insertVeiculosentradabulk, { data: payload, silent: true });

            if (response.status !== 200) {
                console.log(response.data);
                return;
            }

            if (response.data.error) {
                console.log(response.data);
                return;
            }

            return;
        },
        populaRecursos() {
            if (this.user && this.user.is_superadmin === 1) return;
            apiController.request(apiController.endpoints.getRecursosusuario, {
                params: { id: this.user && this.user.id_usuario },
                silent: true,
                onSuccess: (response) => {
                    this.recursos = response.data || [];
                },
                onError: () => {
                    this.recursos = [];
                },
            });
        },
        formatDataHora(valor) {
            if (!valor) return '';
            const d = new Date(valor);
            if (isNaN(d.getTime())) return String(valor);
            const pad = (n) => String(n).padStart(2, '0');
            return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },
        /** Status financeiro (fechamento do dia e do mês) da empresa/dia selecionados. */
        carregaFechamentoDiaFinanceiro() {
            this.fechamentoDiaFinanceiro = null;
            this.fechamentoMesDoDia = null;
            this.statusDiaFinanceiroChave = null;
            if (!this.idEmpresaSelected || !this.dtreferencia) return;
            const chave = `${this.idEmpresaSelected}|${this.dtreferencia}`;
            apiController.request(apiController.endpoints.subsidioGetFechamentodiafinanceiroativo, {
                data: { idempresa: this.idEmpresaSelected, dt_referencia: this.dtreferencia },
                silent: true,
                onSuccess: (response) => {
                    this.fechamentoDiaFinanceiro = (response.data && response.data.fechamento_dia) || null;
                    this.fechamentoMesDoDia = (response.data && response.data.fechamento_mes) || null;
                    this.statusDiaFinanceiroChave = chave;
                },
                onError: () => {
                    // Sem permissão de leitura os botões ficam indisponíveis: sem saber o
                    // status, fechar o dia seria um tiro no escuro.
                    this.statusDiaFinanceiroChave = null;
                },
            });
        },
        abrirDialogFecharDiaFinanceiro() {
            this.observacoesFechamentoDiaFinanceiro = "";
            this.dialogFecharDiaFinanceiro = true;
        },
        confirmarFecharDiaFinanceiro() {
            this.salvandoFechamentoDiaFinanceiro = true;
            apiController.request(apiController.endpoints.subsidioInsertFechamentodiafinanceiro, {
                data: {
                    idempresa: this.idEmpresaSelected,
                    dt_referencia: this.dtreferencia,
                    observacoes: this.observacoesFechamentoDiaFinanceiro || null,
                },
                onSuccess: (response) => {
                    this.salvandoFechamentoDiaFinanceiro = false;
                    this.dialogFecharDiaFinanceiro = false;
                    EventBus.$emit('show-alert', {
                        mensagem: this.$t('closingDay.closeSuccess', {
                            viagens: (response.data && response.data.qtd_viagens) || 0,
                        }),
                    });
                    this.buscaFechamentoDia();
                },
                onError: (error) => {
                    this.salvandoFechamentoDiaFinanceiro = false;
                    EventBus.$emit('show-error', { error });
                },
            });
        },
        abrirDialogReabrirDiaFinanceiro() {
            this.motivoReaberturaDiaFinanceiro = "";
            this.dialogReabrirDiaFinanceiro = true;
        },
        confirmarReabrirDiaFinanceiro() {
            if (!this.motivoReaberturaDiaFinanceiro || !this.motivoReaberturaDiaFinanceiro.trim()) return;
            this.salvandoFechamentoDiaFinanceiro = true;
            apiController.request(apiController.endpoints.subsidioReabrirfechamentodiafinanceiro, {
                data: {
                    id_fechamento_mes: this.fechamentoDiaFinanceiro.id_fechamento_mes,
                    motivo_reabertura: this.motivoReaberturaDiaFinanceiro,
                },
                onSuccess: () => {
                    this.salvandoFechamentoDiaFinanceiro = false;
                    this.dialogReabrirDiaFinanceiro = false;
                    EventBus.$emit('show-alert', { mensagem: this.$t('closingDay.reopenSuccess') });
                    this.buscaFechamentoDia();
                },
                onError: (error) => {
                    this.salvandoFechamentoDiaFinanceiro = false;
                    EventBus.$emit('show-error', { error });
                },
            });
        },
        fecharDia(item) {
            this.editedFechamento = Object.assign({}, item);
            this.dialogFechamentoDia = true;
        },
        insertFechamentoDia() {
            this.$refs.formFechamentoDia.validate();
            if (this.formValidadoFechamentoDia) {
                const payload = {
                    dt_referencia: this.dtreferencia,
                    id_linha: this.editedFechamento.id_linha,
                    id_usuario_fechamento: this.user.id_usuario,
                    observacoes: this.editedFechamento.observacoes,
                }

                apiController.request(apiController.endpoints.insertFechamentodia, {
                    data: payload,
                    silent: true,
                    onSuccess: (response) => {
                        console.log(response.data);
                        this.closeDialogFechamentoDia();
                        this.buscaFechamentoDia();
                    },
                    onError: (error) => {
                        this.closeDialogFechamentoDia();
                        console.log(error);
                    },
                });

            }
        },
        closeDialogFechamentoDia() {
            this.dialogFechamentoDia = false;
            this.editedFechamento = Object.assign({}, this.defaultFechamento);
            if (this.$refs.formFechamentoDia) {
                this.$refs.formFechamentoDia.resetValidation();
            }
        },
        filterLinha(item) {
            if (this.idLinhaFiltered === item.id_linha) {
                this.idLinhaFiltered = null;
            } else {
                this.idLinhaFiltered = item.id_linha;
            }
            this.embarquesSelected = [];
        },
        openDialogAssociarEmbarques() {
            if (this.embarquesSelected.length === 0) {
                return;
            }
            this.idViagemAssociacaoSelected = null;
            this.dialogAssociarEmbarques = true;
        },
        closeDialogAssociarEmbarques() {
            this.dialogAssociarEmbarques = false;
            this.idViagemAssociacaoSelected = null;
        },
        confirmAssociarEmbarques() {
            if (!this.idViagemAssociacaoSelected || this.embarquesSelected.length === 0) {
                return;
            }

            const payload = {
                id_viagem_grid: this.idViagemAssociacaoSelected,
                ids_embarques: this.embarquesSelected.map(e => e.id_embarque),
                id_usuario_associacao_manual: this.user.id_usuario,
                dt_associacao_manual: DateUtils.getDateSQLFormatted(new Date()),
            };

            apiController.request(apiController.endpoints.associaRembarquesviagembulk, {
                data: payload,
                silent: true,
                onSuccess: (response) => {
                    if (response.data.erro) {
                        console.log(response.data);
                        return;
                    }
                    this.closeDialogAssociarEmbarques();
                    this.populaEmbarques();
                    this.populaViagens();
                },
                onError: (error) => {
                    console.log(error);
                },
            });
        },
        atualizaEscalonamento() {
            this.editedViagem.escalonamento_veiculo = this.guias.find((guia) => guia.id_guia == this.editedViagem.id_guia_realizada)?.escalonamento;
        },
    },
}
</script>
<style>
.fechamento-dia__viagem-invalida {
    background-color: rgba(255, 87, 34, 0.14) !important;
}

.fechamento-dia__viagem-invalida td {
    color: rgb(191, 54, 12);
    font-weight: 500;
}
</style>